<!-- Header da Pagina -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-box"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ 'produtos.texts.adicionar_produto' | translate }}</h1>
    <p class="header-subtitle">{{ 'produtos.texts.subtitulo_adicionar' | translate }}</p>
  </div>
</div>

<!-- Grid de Cards -->
<div class="cards-container">
  <!-- Coluna Esquerda -->
  <div class="column-left">
    <!-- Card Informacao Geral -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon">
          <i class="pi pi-info-circle"></i>
        </div>
        <span class="card-header-title">{{ 'produtos.texts.informacao_geral' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.nome' | translate }} <span class="required">*</span></label>
            <input [class.error-field]="isFormSubmitted && !form.nome" [(ngModel)]="form.nome" type="text" pInputText
              placeholder="{{ 'produtos.placeholders.digite_o_nome' | translate }}" class="w-full" />
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.codigo_de_barras' | translate }}</label>
            <input [(ngModel)]="form.barras" type="text" pInputText
              placeholder="{{ 'produtos.placeholders.digite_o_codigo' | translate }}" class="w-full" />
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.grupo' | translate }} <span class="required">*</span></label>
            <app-select-grupo id="categoria" [(ngModel)]="form.grupo_id" [returnType]="'id'" (ngModelChange)="onGrupoChange($event)" [class.error-field]="isFormSubmitted && !form.grupo_id" />
            <small class="error-message" *ngIf="isFormSubmitted && !form.grupo_id">{{ 'common.campo_obrigatorio' | translate }}</small>
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.sub_grupo' | translate }}</label>
            <app-select-subgrupo id="subCategoria" [(ngModel)]="form.subGrupo_id" [returnType]="'id'" [grupoId]="form.grupo_id" />
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.marca' | translate }}</label>
            <app-select-marca id="marca" [(ngModel)]="form.marca_id" [returnType]="'id'" />
          </div>
          <div class="form-field full">
            <label class="form-label">{{ 'produtos.labels.tipo_de_item' | translate }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoItem" [options]="tipoDeItensOptions"
              optionLabel="label" [(ngModel)]="form.tipoItem"
              placeholder="{{ 'produtos.placeholders.selecionar_tipo_produto' | translate }}" styleClass="w-full"></p-dropdown>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.preco_de_venda' | translate }} <span class="required">*</span></label>
            <p-inputNumber
              [(ngModel)]="form.precoDeVenda"
              [currency]="currencyCode"
              [locale]="locale"
              [minFractionDigits]="casasDecimaisDaMoeda"
              [maxFractionDigits]="casasDecimaisDaMoeda"
              [useGrouping]="true"
              [monetaryMask]="casasDecimaisDaMoeda"
              [min]="0"
              [allowEmpty]="true"
              (onFocus)="onPrecoDeVendaFocus()"
              (onBlur)="onPrecoDeVendaBlur()"
              [class.error-field]="isFormSubmitted && precoDeVendaInvalido"
              [placeholder]="'produtos.placeholders.digite_o_preco' | translate"
              inputStyleClass="w-full"
              styleClass="w-full">
            </p-inputNumber>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.custo' | translate }} <span class="required">*</span></label>
            <p-inputNumber
              [(ngModel)]="form.custo"
              [currency]="currencyCode"
              [locale]="locale"
              [minFractionDigits]="casasDecimaisDaMoeda"
              [maxFractionDigits]="casasDecimaisDaMoeda"
              [useGrouping]="true"
              [monetaryMask]="casasDecimaisDaMoeda"
              [class.error-field]="isFormSubmitted && form.custo == null"
              [placeholder]="'produtos.placeholders.digite_o_custo' | translate"
              inputStyleClass="w-full"
              styleClass="w-full">
            </p-inputNumber>
          </div>
          <div class="form-field full">
            <label class="form-label">{{ 'produtos.labels.descricao' | translate }}</label>
            <textarea [(ngModel)]="form.descricao" pInputTextarea [rows]="2" [autoResize]="true"
              placeholder="{{ 'produtos.placeholders.digite_a_descricao' | translate }}" class="w-full"></textarea>
          </div>
          <div class="form-field full">
            <label class="form-label">{{ 'produtos.labels.imagem' | translate }}</label>
            <p-fileUpload name="grupo" [multiple]="false" accept="image/jpeg,image/png,image/gif" [maxFileSize]="2000000"
              [showUploadButton]="false" [showCancelButton]="true"
              chooseLabel="{{'grupo.botoes.selecionar_imagem' | translate}}"
              cancelLabel="{{'grupo.botoes.remover' | translate}}" (onSelect)="onSelectImage($event)"
              (onClear)="onClearImage()">
            </p-fileUpload>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Estoque -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon stock-icon">
          <i class="pi pi-warehouse"></i>
        </div>
        <span class="card-header-title">{{ 'produtos.texts.estoque' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.saldo' | translate }} <span class="required">*</span></label>
            <app-input-quantidade [class.error-field]="isFormSubmitted && form.saldo == null" [(ngModel)]="form.saldo"
              [casasDecimais]="casasDecimaisEstoque"
              [style]="{ width: '100%' }"></app-input-quantidade>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.estoque_minimo' | translate }} <span class="required">*</span></label>
            <app-input-quantidade [class.error-field]="isFormSubmitted && form.estoqueMinimo == null" [(ngModel)]="form.estoqueMinimo"
              [casasDecimais]="casasDecimaisEstoque"
              [style]="{ width: '100%' }"></app-input-quantidade>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.unidade_de_medida' | translate }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.unidadeMedidaDeItem_id" [options]="unidadesMedida"
              optionLabel="label" optionValue="value" [(ngModel)]="form.unidadeMedidaDeItem_id"
              (onChange)="onUnidadeMedidaChange()"
              placeholder="{{ 'produtos.placeholders.selecionar_unidade_medida' | translate }}" styleClass="w-full"></p-dropdown>
          </div>
          <div class="form-field half">
            <label class="form-label">{{ 'produtos.labels.fornecedor_principal' | translate }}</label>
            <p-dropdown [options]="fornecedores" optionLabel="label" [(ngModel)]="form.fornecedorPrincipal_id"
              placeholder="{{ 'produtos.placeholders.selecionar_fornecedor' | translate }}" styleClass="w-full"></p-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Coluna Direita -->
  <div class="column-right">
    <!-- Card Dados Adicionais -->
    <div class="form-card">
      <div class="card-header">
        <div class="card-header-icon additional-icon">
          <i class="pi pi-cog"></i>
        </div>
        <span class="card-header-title">{{ 'produtos.texts.dados_adicionais' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.tipo_de_imposto' | translate }} <span class="required">*</span></label>
            <p-dropdown [class.error-field]="isFormSubmitted && !form.tipoDeImposto" [options]="tipoDeImpostoOptions"
              optionLabel="label" optionValue="value" [(ngModel)]="form.tipoDeImposto" styleClass="w-full"></p-dropdown>
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.disponivel_mini_shop' | translate }}</label>
            <div class="status-toggle-container">
              <p-inputSwitch
                [(ngModel)]="form.habilitarMiniShopping"
                [disabled]="!habilitarMiniShoppingEmpresaConfig"
                (onChange)="onMiniShopChange()"
                class="status-switch">
              </p-inputSwitch>
              <span class="status-label" [ngClass]="{'status-active': form.habilitarMiniShopping, 'status-inactive': !form.habilitarMiniShopping}">
                {{ form.habilitarMiniShopping ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field half" *ngIf="imprimirItensDeAcordoImpressoraEmpresaConfig">
            <label class="form-label">{{ 'produtos.labels.impressora_predeterminada' | translate }}</label>
            <p-dropdown [options]="impressoras" optionLabel="label" [(ngModel)]="form.impressoraPadraoId" styleClass="w-full"></p-dropdown>
          </div>
          <div class="form-field half" *ngIf="imprimirItensDeAcordoImpressoraEmpresaConfig">
            <label class="form-label">{{ 'produtos.labels.imprimir_itens_segundo_impressora' | translate }}</label>
            <p-dropdown [options]="permiteImprimir" optionLabel="label" optionValue="value"
              [(ngModel)]="form.permiteImprimir" styleClass="w-full">
            </p-dropdown>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Promocao e Novidade (visivel apenas com MiniShop ativo) -->
    <div class="form-card" *ngIf="form.habilitarMiniShopping">
      <div class="card-header">
        <div class="card-header-icon additional-icon">
          <i class="pi pi-star"></i>
        </div>
        <span class="card-header-title">{{ 'produtos.texts.promocao_e_novidade' | translate }}</span>
      </div>
      <div class="card-content">
        <div class="form-grid">
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.promocao' | translate }}</label>
            <div class="status-toggle-container">
              <p-inputSwitch
                inputId="switchPromocao"
                [(ngModel)]="promocao"
                (onChange)="onPromocaoChange()"
                class="status-switch">
              </p-inputSwitch>
              <span class="status-label" [ngClass]="{'status-active': promocao, 'status-inactive': !promocao}">
                {{ promocao ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field third" *ngIf="promocao">
            <label class="form-label">{{ 'produtos.labels.promocao_ate' | translate }} <span class="required">*</span></label>
            <p-calendar
              [(ngModel)]="promocaoAteEmData"
              [showTime]="true"
              [showSeconds]="false"
              hourFormat="24"
              [minDate]="dataMinimaPromocaoNovidade"
              appendTo="body"
              dateFormat="dd/mm/yy"
              styleClass="w-full">
            </p-calendar>
          </div>
          <div class="form-field third">
            <label class="form-label">{{ 'produtos.labels.novidade' | translate }}</label>
            <div class="status-toggle-container">
              <p-inputSwitch
                inputId="switchNovidade"
                [(ngModel)]="novidade"
                (onChange)="onNovidadeChange()"
                class="status-switch">
              </p-inputSwitch>
              <span class="status-label" [ngClass]="{'status-active': novidade, 'status-inactive': !novidade}">
                {{ novidade ? ('produtos.labels.sim' | translate) : ('produtos.labels.nao' | translate) }}
              </span>
            </div>
          </div>
          <div class="form-field third" *ngIf="novidade">
            <label class="form-label">{{ 'produtos.labels.novidade_ate' | translate }} <span class="required">*</span></label>
            <p-calendar
              [(ngModel)]="novidadeAteEmData"
              [showTime]="true"
              [showSeconds]="false"
              hourFormat="24"
              [minDate]="dataMinimaPromocaoNovidade"
              appendTo="body"
              dateFormat="dd/mm/yy"
              styleClass="w-full">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>

    <!-- Card Variantes de Preco -->
    <div class="form-card variantes-card">
      <div class="card-header">
        <div class="card-header-icon variantes-icon">
          <i class="pi pi-tags"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.variantes_de_preco' | translate }}</span>
      </div>
      <div class="card-content">
        <p class="variantes-descricao">{{ 'produtos-edit.texts.variantes_descricao' | translate }}</p>

        <!-- Lista de variantes -->
        <div *ngFor="let variante of variantes; let i = index" class="variante-item">
          <div class="variante-campos">
            <div class="form-field variante-descricao-field">
              <label class="form-label">{{ 'produtos-edit.labels.variante_descricao' | translate }}</label>
              <input
                [(ngModel)]="variante.descricao"
                type="text"
                pInputText
                placeholder="{{ 'produtos-edit.placeholders.variante_descricao' | translate }}"
                class="w-full" />
            </div>
            <div class="form-field variante-preco-field">
              <label class="form-label">{{ 'produtos-edit.labels.variante_preco' | translate }}</label>
              <p-inputNumber
                [(ngModel)]="variante.precoDeVenda"
                [currency]="currencyCode"
                [locale]="locale"
                [minFractionDigits]="casasDecimaisDaMoeda"
                [maxFractionDigits]="casasDecimaisDaMoeda"
                [useGrouping]="true"
                [monetaryMask]="casasDecimaisDaMoeda"
                placeholder="0"
                inputStyleClass="w-full"
                styleClass="w-full">
              </p-inputNumber>
            </div>
          </div>
          <div class="variante-acoes">
            <button pButton
              icon="pi pi-trash"
              class="p-button-rounded p-button-text p-button-danger"
              (click)="removerVariante(i)"
              [pTooltip]="'produtos-edit.tooltips.remover_variante' | translate">
            </button>
          </div>
        </div>

        <!-- Estado vazio -->
        <div *ngIf="variantes.length === 0" class="variantes-empty">
          <i class="pi pi-tags variantes-empty-icon"></i>
          <p>{{ 'produtos-edit.texts.sem_variantes' | translate }}</p>
        </div>

        <!-- Botao adicionar variante -->
        <button pButton
          icon="pi pi-plus"
          class="p-button-outlined p-button-sm w-full btn-adicionar-variante"
          (click)="adicionarVariante()">
          {{ 'produtos-edit.botoes.adicionar_variante' | translate }}
        </button>
      </div>
    </div>

    <!-- Card Grupos de Modificadores -->
    <div class="form-card modificadores-card">
      <div class="card-header">
        <div class="card-header-icon modificadores-icon">
          <i class="pi pi-sliders-h"></i>
        </div>
        <span class="card-header-title">{{ 'produtos-edit.texts.modificadores' | translate }}</span>
      </div>
      <div class="card-content">
        <p class="variantes-descricao">{{ 'produtos-edit.texts.modificadores_descricao' | translate }}</p>

        <!-- Lista de grupos de modificadores -->
        <div *ngFor="let grupo of gruposModificadores; let gi = index" class="grupo-modificador">

          <!-- Cabecalho do grupo -->
          <div class="grupo-header">
            <div class="grupo-campos-vertical">
              <div class="grupo-nome-row">
                <div class="form-field flex-1">
                  <label class="form-label">{{ 'produtos-edit.labels.grupo_modificador_pergunta' | translate }}</label>
                  <input
                    [(ngModel)]="grupo.descricao"
                    type="text"
                    pInputText
                    placeholder="{{ 'produtos-edit.placeholders.grupo_modificador_pergunta' | translate }}"
                    class="w-full" />
                </div>
                <div class="grupo-acoes">
                  <button pButton
                    icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-danger"
                    (click)="removerGrupoModificador(gi)"
                    [pTooltip]="'produtos-edit.tooltips.remover_grupo' | translate">
                  </button>
                </div>
              </div>
              <div class="grupo-config-row">
                <div class="grupo-toggle-item">
                  <label class="form-label">{{ 'produtos-edit.labels.cliente_deve_escolher' | translate }}</label>
                  <p-inputSwitch
                    [ngModel]="grupo.minimoDeModificadores > 0"
                    (ngModelChange)="onToggleObrigatorio(gi, $event)">
                  </p-inputSwitch>
                </div>
                <div class="grupo-toggle-item">
                  <label class="form-label">{{ 'produtos-edit.labels.pode_escolher_mais_de_um' | translate }}</label>
                  <p-inputSwitch
                    [ngModel]="grupo.maximoDeModificadores > 1"
                    (ngModelChange)="onToggleMultiplo(gi, $event)">
                  </p-inputSwitch>
                </div>
                <div class="grupo-toggle-item" *ngIf="grupo.maximoDeModificadores > 1">
                  <label class="form-label">{{ 'produtos-edit.labels.ate_quantos' | translate }}</label>
                  <p-inputNumber
                    [(ngModel)]="grupo.maximoDeModificadores"
                    [min]="2"
                    [max]="20"
                    styleClass="grupo-ate-quantos-input">
                  </p-inputNumber>
                </div>
              </div>
            </div>
          </div>

          <!-- Opcoes do grupo -->
          <div class="opcoes-container">
            <label class="opcoes-section-label">{{ 'produtos-edit.labels.opcoes_disponiveis' | translate }}</label>
            <div *ngFor="let mod of grupo.modificadores; let mi = index" class="opcao-item">
              <div class="form-field flex-1">
                <label class="form-label" *ngIf="mi === 0">{{ 'produtos-edit.labels.opcao_nome' | translate }}</label>
                <input
                  [(ngModel)]="mod.descricao"
                  type="text"
                  pInputText
                  placeholder="{{ 'produtos-edit.placeholders.opcao_nome' | translate }}"
                  class="w-full" />
              </div>
              <div class="form-field opcao-preco-field">
                <label class="form-label" *ngIf="mi === 0">{{ 'produtos-edit.labels.preco_adicional' | translate }}</label>
                <p-inputNumber
                  [(ngModel)]="mod.precoDeVenda"
                  [currency]="currencyCode"
                  [locale]="locale"
                  [minFractionDigits]="casasDecimaisDaMoeda"
                  [maxFractionDigits]="casasDecimaisDaMoeda"
                  [useGrouping]="true"
                  [monetaryMask]="casasDecimaisDaMoeda"
                  placeholder="0"
                  inputStyleClass="w-full"
                  styleClass="w-full">
                </p-inputNumber>
              </div>
              <button pButton
                icon="pi pi-trash"
                class="p-button-rounded p-button-text p-button-danger p-button-sm"
                [ngClass]="{'opcao-btn-primeira-linha': mi === 0}"
                (click)="removerModificador(gi, mi)"
                [pTooltip]="'produtos-edit.tooltips.remover_opcao' | translate">
              </button>
            </div>

            <!-- Botao adicionar opcao -->
            <button pButton
              icon="pi pi-plus"
              class="p-button-text p-button-sm btn-adicionar-opcao"
              (click)="adicionarModificador(gi)">
              {{ 'produtos-edit.botoes.adicionar_opcao' | translate }}
            </button>
          </div>
        </div>

        <!-- Estado vazio -->
        <div *ngIf="gruposModificadores.length === 0" class="variantes-empty">
          <i class="pi pi-sliders-h variantes-empty-icon"></i>
          <p>{{ 'produtos-edit.texts.sem_modificadores' | translate }}</p>
        </div>

        <!-- Botao adicionar grupo -->
        <button pButton
          icon="pi pi-plus"
          class="p-button-outlined p-button-sm w-full btn-adicionar-variante"
          (click)="adicionarGrupoModificador()">
          {{ 'produtos-edit.botoes.adicionar_grupo_modificador' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Botoes de Acao -->
<div class="actions-container">
  <button pButton (click)="navigateListaDeProdutos()"
    severity="secondary" icon="pi pi-arrow-left" class="btn-secondary">
    {{ 'add-cliente.botoes.voltar' | translate }} (Esc)
  </button>
  <button pButton icon="pi pi-check"
    (click)="submit()" [disabled]="submitting" [loading]="submitting" class="btn-primary">
    {{ 'produtos.botoes.salvar' | translate }} (Ctrl+Enter)
  </button>
</div>

<p-toast></p-toast>
